module.exports = __webpack_public_path__ + "img/logo_consulta_branco.225d99bb.png";